import { render, staticRenderFns } from "./NurseryStaffMobile.vue?vue&type=template&id=a46b00e0"
import script from "./NurseryStaffMobile.vue?vue&type=script&lang=js"
export * from "./NurseryStaffMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports